import { ReactNode } from "react"
import { Button, ButtonProps, DialogActions, Stack } from "@mui/material"
import { CloseIcon, OkIcon } from "shared/icons"

type ButtonParameter = {
  label?: string
  icon?: ReactNode
  onClick: () => void
}
type DialogActionButtonProps = {
  submit?: boolean
  param?: ButtonParameter
  onClick?: () => void
  label: string
  icon?: ReactNode
  variant: "contained" | "text"
} & ButtonProps
const DialogActionButton = ({
  submit,
  param,
  onClick,
  label,
  icon,
  variant,
  ...others
}: DialogActionButtonProps) => param ? (
  <Button variant={variant} size="large" startIcon={param.icon ?? icon} onClick={param.onClick} {...others}>
    {param.label ?? label}
  </Button>
) : onClick ? (
  <Button variant={variant} size="large" startIcon={icon} onClick={onClick} {...others}>
    {label}
  </Button>
) : submit ? (
  <Button variant={variant} size="large" type="submit" startIcon={icon} {...others}>
    {label}
  </Button>
) : <></>

export type DialogActionProps = {
  left?: ReactNode
  right?: ReactNode
  center?: ReactNode
  submit?: boolean
  isValid?: boolean
  label?: string
  ok?: ButtonParameter
  onOk?: () => void
  cancel?: ButtonParameter
  onCancel?: () => void
  close?: ButtonParameter
  onClose?: () => void
}
export const DialogAction = ({
  left, right, center,
  submit, isValid, label,
  ok, cancel, close,
  onOk, onCancel, onClose
}: DialogActionProps) => (
  left || right || center || 
  submit || ok || onOk || cancel || onCancel ||
  close || onClose
) ? (
  <DialogActions sx={{
    justifyContent: 
      left ? ((right || submit || ok || onOk || cancel || onCancel || close || onClose) ? 'space-between' : 'flex-start') :
      (right || submit || ok || onOk || cancel || onCancel) ? 'flex-end' :
      'center',
    padding: "20px 24px"
  }}>
    {left && <Stack direction="row" spacing={2}>{left}</Stack>}
    {center}
    {(right || submit || ok || onOk || cancel || onCancel) && (
      <Stack direction="row" spacing={2}>
        {right}
        <DialogActionButton
          submit={submit}
          disabled={isValid === false}
          label={label ?? "登録"}
          icon={<OkIcon/>}
          variant="contained"
        />
        <DialogActionButton
          param={ok}
          onClick={onOk}
          label="OK"
          icon={<OkIcon/>}
          variant="contained"
        />
        <DialogActionButton
          param={cancel}
          onClick={onCancel}
          label="キャンセル"
          variant="text"
        />
      </Stack>
    )}
    <DialogActionButton
      param={close}
      onClick={onClose}
      icon={<CloseIcon/>}
      label="閉じる"
      variant="text"
    />
  </DialogActions>
) : <></>
